import script from "./AudioPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./AudioPlayer.vue?vue&type=style&index=0&id=2d974580&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d974580"]])

export default __exports__